import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AdminService } from '../../services/AdminService/admin';
import { extractErrorMessage } from '../../shared/error-utils';
import { ErrorBanner } from '../../shared/components/error-banner/error-banner';
import { CountrySelect } from '../../shared/components/country-select/country-select';

@Component({
  selector: 'app-upsert-country-mapping-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ErrorBanner,
    CountrySelect,
  ],
  templateUrl: './upsert-country-mapping-dialog.html',
  styleUrl: './upsert-country-mapping-dialog.scss',
})
export class UpsertCountryMappingDialog {
  countryCode = '';
  network = '';
  schemaProfile = '';

  isSubmitting = signal(false);
  errorMessage = signal('');

  constructor(private dialogRef: MatDialogRef<UpsertCountryMappingDialog>, private admin: AdminService) {}

  get canSubmit(): boolean {
    return !!this.countryCode.trim() && !!this.network.trim();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (!this.canSubmit) {
      return;
    }

    this.isSubmitting.set(true);
    this.errorMessage.set('');

    this.admin
      .upsertCountryMapping(this.countryCode.toUpperCase(), {
        network: this.network,
        schemaProfile: this.schemaProfile || undefined,
      })
      .subscribe({
        next: () => {
          this.isSubmitting.set(false);
          this.dialogRef.close(true);
        },
        error: (err: HttpErrorResponse) => {
          this.isSubmitting.set(false);
          this.errorMessage.set(extractErrorMessage(err, 'Failed to save country mapping.'));
        },
      });
  }
}
